(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('GiftcardStatementDeleteController',GiftcardStatementDeleteController);

    GiftcardStatementDeleteController.$inject = ['$uibModalInstance', 'entity', 'GiftcardStatement'];

    function GiftcardStatementDeleteController($uibModalInstance, entity, GiftcardStatement) {
        var vm = this;

        vm.giftcardStatement = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GiftcardStatement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
